import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { mutedSmallStyle } from './vinExtractionStyles';
import CarStatusTag from './CarStatusTag';

const CarStatusCell = ({ car }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex vertical align="flex-start" gap={spacing[0.5]}>
            <CarStatusTag status={car.status} />
            {car.viaLiveRetry && <span style={mutedSmallStyle}>{t('cars.viaLiveRetry')}</span>}
        </Flex>
    );
};

export default CarStatusCell;
